export const T = {
  ink: "#171717",
  inkSoft: "#3D3D3B",
  muted: "#6E6E6E",
  faint: "#C4C2BB",
  border: "rgba(0,0,0,0.06)",
  surface: "#FBFAF8",
  paper: "#FFFFFF",
  white: "#FFFFFF",
  // Greenbless brand green (sampled from the logo) — replaces the old gold accent
  gold: "#0E6838",
  goldLight: "#E3F0E7",
  goldHover: "#0A522B",
  shadowSoft: "0 8px 24px rgba(0,0,0,0.04)",
  shadowMedium: "0 12px 32px rgba(0,0,0,0.05)",
};
